import JSEncrypt from 'jsencrypt'

const RSA_PUBLIC_KEY = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwIfSMxRzJpg0UQqbqRlV
sOQ/xshxAH9UIDqfs+1mqTD9pJXzvrJ6SOiFN2Iu77pBifSTJOf67xhWubciuXnG
DLu44CaiEqzX/cQ2A0TiJF3KEKwu8OhMsSE6RgiEOB8ku0ddj+IlCbRTwvqafI+v
cj9MuOTP+BtaNDlnH+XrQCYNfa4x/SBPqxPpZRjx/PQQxxxGCb9oBbM1JPlW27ps
chUehuSNI6IcRBOy9svGSbon0zBjhmvRnx31scuDMyYpVKNmrXu7YC1/hkiAw82w
czXAxWifu3vhV6CwN1W+AMQY83Q/mbMH23KdNk+CSCOuUClTS1apO7FJQAnpw/d0
3QIDAQAB
-----END PUBLIC KEY-----
`

const encryptor = new JSEncrypt()
encryptor.setPublicKey(RSA_PUBLIC_KEY)

/**
 * 使用 RSA 公钥加密文本
 *
 * @param {string} text - 需要加密的文本
 * @returns {string} 加密后的字符串，如果输入为空或加密失败则返回空字符串
 */
export function rsaEncrypt(text) {
  if (!text) return ''
  return encryptor.encrypt(text) || ''
}